// src/pages/Warehouses/Warehouses.jsx

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, onSnapshot, writeBatch, doc, deleteDoc, updateDoc, query } from 'firebase/firestore';
import { db } from '../../firebase';
import { useAuth } from '../../context/AuthContext';

const styles = {
    container: {
        fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        background: 'transparent'
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '32px'
    },
    title: {
        fontSize: '32px',
        fontWeight: '700',
        color: '#0f172a',
        margin: 0,
        letterSpacing: '-0.5px'
    },
    button: {
        padding: '12px 24px',
        border: 'none',
        background: 'linear-gradient(135deg, #06C167, #8b5cf6)',
        color: 'white',
        borderRadius: '12px',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: '600',
        transition: 'all 0.2s ease-in-out',
        boxShadow: '0 4px 12px rgba(99, 102, 241, 0.3)'
    },
    box: {
        background: 'white',
        padding: '32px',
        borderRadius: '16px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        border: '1px solid #e2e8f0'
    },
    tableContainer: {
        borderRadius: '12px',
        border: '1px solid #e2e8f0',
        overflow: 'hidden'
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse'
    },
    th: {
        background: '#f8fafc',
        padding: '16px 20px',
        textAlign: 'left',
        borderBottom: '1px solid #e2e8f0',
        color: '#374151',
        fontSize: '12px',
        fontWeight: '600',
        textTransform: 'uppercase',
        letterSpacing: '0.5px'
    },
    td: {
        padding: '16px 20px',
        borderBottom: '1px solid #f1f5f9',
        color: '#374151',
        fontSize: '14px'
    },
    trHover: {
        cursor: 'pointer',
        transition: 'background-color 0.2s'
    },
    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 100,
        backdropFilter: 'blur(4px)'
    },
    modalContent: {
        background: 'white',
        padding: '32px',
        borderRadius: '16px',
        width: '90%',
        maxWidth: '500px',
        boxShadow: '0 25px 50px rgba(0,0,0,0.25)',
        border: '1px solid #e2e8f0'
    },
    modalHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '24px',
        paddingBottom: '16px',
        borderBottom: '1px solid #e2e8f0'
    },
    modalTitle: {
        fontSize: '20px',
        fontWeight: '600',
        color: '#0f172a',
        margin: 0
    },
    closeButton: {
        background: 'none',
        border: 'none',
        fontSize: '24px',
        cursor: 'pointer',
        color: '#64748b',
        padding: '4px',
        borderRadius: '8px'
    },
    modalActions: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '12px',
        marginTop: '24px',
        paddingTop: '16px',
        borderTop: '1px solid #e2e8f0'
    },
    formGroup: {
        marginBottom: '16px'
    },
    label: {
        display: 'block',
        marginBottom: '6px',
        fontWeight: '500',
        color: '#374151',
        fontSize: '14px'
    },
    input: {
        width: '100%',
        padding: '12px 16px',
        fontSize: '14px',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        boxSizing: 'border-box',
        background: '#fff',
        outline: 'none'
    },
    deleteButton: {
        background: '#dc2626',
        color: 'white',
        border: 'none',
        padding: '6px 12px',
        borderRadius: '6px',
        cursor: 'pointer',
        fontSize: '12px'
    }
};

function AddWarehouseModal({ onClose, onSave }) {
    const [newWarehouse, setNewWarehouse] = useState({
        name: '',
        location: '',
        isActive: true
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setNewWarehouse(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!newWarehouse.name.trim()) {
            alert("Depo adı boş olamaz");
            return;
        }
        onSave(newWarehouse);
    };

    return (
        <div style={styles.modalOverlay} onClick={onClose}>
            <div style={styles.modalContent} onClick={e => e.stopPropagation()}>
                <div style={styles.modalHeader}>
                    <h2 style={styles.modalTitle}>Yeni Depo Ekle</h2>
                    <button onClick={onClose} style={styles.closeButton}>&times;</button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div style={styles.formGroup}>
                        <label style={styles.label}>Depo Adı</label>
                        <input
                            style={styles.input}
                            type="text"
                            name="name"
                            value={newWarehouse.name}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div style={styles.formGroup}>
                        <label style={styles.label}>Lokasyon</label>
                        <input
                            style={styles.input}
                            type="text"
                            name="location"
                            value={newWarehouse.location}
                            onChange={handleChange}
                        />
                    </div>
                    <div style={styles.formGroup}>
                        <label style={styles.label}>
                            <input
                                type="checkbox"
                                name="isActive"
                                checked={newWarehouse.isActive}
                                onChange={handleChange}
                            /> Aktif
                        </label>
                    </div>
                    <div style={styles.modalActions}>
                        <button type="button" onClick={onClose} style={{ ...styles.button, background: '#6c757d' }}>İptal</button>
                        <button type="submit" style={{ ...styles.button, background: '#198754' }}>Kaydet</button>
                    </div>
                </form>
            </div>
        </div>
    );
}

function EditWarehouseModal({ warehouse, onClose, onSave }) {
    const [editedWarehouse, setEditedWarehouse] = useState(warehouse);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setEditedWarehouse(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!editedWarehouse.name.trim()) {
            alert("Depo adı boş olamaz");
            return;
        }
        onSave(editedWarehouse);
    };

    return (
        <div style={styles.modalOverlay} onClick={onClose}>
            <div style={styles.modalContent} onClick={e => e.stopPropagation()}>
                <div style={styles.modalHeader}>
                    <h2 style={styles.modalTitle}>Depo Düzenle</h2>
                    <button onClick={onClose} style={styles.closeButton}>&times;</button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div style={styles.formGroup}>
                        <label style={styles.label}>Depo Adı</label>
                        <input
                            style={styles.input}
                            type="text"
                            name="name"
                            value={editedWarehouse.name}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div style={styles.formGroup}>
                        <label style={styles.label}>Lokasyon</label>
                        <input
                            style={styles.input}
                            type="text"
                            name="location"
                            value={editedWarehouse.location}
                            onChange={handleChange}
                        />
                    </div>
                    <div style={styles.formGroup}>
                        <label style={styles.label}>
                            <input
                                type="checkbox"
                                name="isActive"
                                checked={editedWarehouse.isActive}
                                onChange={handleChange}
                            /> Aktif
                        </label>
                    </div>
                    <div style={styles.modalActions}>
                        <button type="button" onClick={onClose} style={{ ...styles.button, background: '#6c757d' }}>İptal</button>
                        <button type="submit" style={{ ...styles.button, background: '#198754' }}>Kaydet</button>
                    </div>
                </form>
            </div>
        </div>
    );
}

function Warehouses() {
    const { userData } = useAuth();
    const navigate = useNavigate();
    const [warehouses, setWarehouses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [selectedWarehouse, setSelectedWarehouse] = useState(null);

    useEffect(() => {
        if (!userData?.companyId) {
            setLoading(false);
            return;
        }

        const companyId = userData.companyId;
        const unsubWarehouses = onSnapshot(
            query(collection(db, 'companies', companyId, 'warehouses')),
            snap => {
                setWarehouses(snap.docs.map(d => ({ id: d.id, ...d.data() })));
                setLoading(false);
            }
        );

        return () => unsubWarehouses();
    }, [userData]);

    const handleAddWarehouse = async (warehouseData) => {
        if (!userData?.companyId) return;

        // Duplicate name check
        const existingWarehouse = warehouses.find(w => w.name.trim().toLowerCase() === warehouseData.name.trim().toLowerCase());
        if (existingWarehouse) {
            alert('Bu isimde bir depo zaten mevcut! Lütfen farklı bir isim kullanın.');
            return;
        }

        const companyId = userData.companyId;
        const batch = writeBatch(db);
        const warehouseRef = doc(collection(db, 'companies', companyId, 'warehouses'));

        batch.set(warehouseRef, {
            ...warehouseData,
            createdAt: new Date()
        });

        try {
            await batch.commit();
            setShowAddModal(false);
        } catch (error) {
            console.error("Depo eklenirken hata:", error);
            alert("Depo eklenirken bir hata oluştu.");
        }
    };

    const handleEditWarehouse = async (warehouseData) => {
        if (!userData?.companyId || !warehouseData.id) return;

        // Duplicate name check (exclude current warehouse)
        const existingWarehouse = warehouses.find(w => w.id !== warehouseData.id && w.name.trim().toLowerCase() === warehouseData.name.trim().toLowerCase());
        if (existingWarehouse) {
            alert('Bu isimde bir depo zaten mevcut! Lütfen farklı bir isim kullanın.');
            return;
        }

        const companyId = userData.companyId;
        const warehouseRef = doc(db, 'companies', companyId, 'warehouses', warehouseData.id);

        try {
            await updateDoc(warehouseRef, {
                name: warehouseData.name,
                location: warehouseData.location,
                isActive: warehouseData.isActive,
                updatedAt: new Date()
            });
            setShowEditModal(false);
            setSelectedWarehouse(null);
        } catch (error) {
            console.error("Depo güncellenirken hata:", error);
            alert("Depo güncellenirken bir hata oluştu.");
        }
    };

    const handleDeleteWarehouse = async (warehouseId) => {
        if (!userData?.companyId || !warehouseId) return;

        if (!window.confirm("Bu depoyu silmek istediğinize emin misiniz?")) {
            return;
        }

        const companyId = userData.companyId;
        try {
            await deleteDoc(doc(db, 'companies', companyId, 'warehouses', warehouseId));
        } catch (error) {
            console.error("Depo silinirken hata:", error);
            alert("Depo silinirken bir hata oluştu.");
        }
    };

    return (
        <div style={styles.container}>
            <div style={{ width: '100%' }}>
                <div style={styles.header}>
                    <h1 style={styles.title}>Depo Yönetimi</h1>
                    <button onClick={() => setShowAddModal(true)} style={styles.button}>Yeni Depo Ekle</button>
                </div>
                <div style={styles.box}>
                    {loading ? (
                        <p>Yükleniyor...</p>
                    ) : (
                        <div style={styles.tableContainer}>
                            <table style={styles.table}>
                                <thead>
                                    <tr>
                                        <th style={styles.th}>Depo Adı</th>
                                        <th style={styles.th}>Lokasyon</th>
                                        <th style={styles.th}>Durum</th>
                                        <th style={styles.th}>İşlemler</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {warehouses.map(warehouse => (
                                        <tr key={warehouse.id} style={styles.trHover}>
                                            <td style={styles.td}>{warehouse.name}</td>
                                            <td style={styles.td}>{warehouse.location || '-'}</td>
                                            <td style={styles.td}>
                                                <span style={{
                                                    padding: '4px 8px',
                                                    borderRadius: '4px',
                                                    backgroundColor: warehouse.isActive ? '#dcfce7' : '#fee2e2',
                                                    color: warehouse.isActive ? '#06C167' : '#b91c1c',
                                                    fontSize: '12px',
                                                    fontWeight: '500'
                                                }}>
                                                    {warehouse.isActive ? 'Aktif' : 'Pasif'}
                                                </span>
                                            </td>
                                            <td style={styles.td}>
                                                <button
                                                    onClick={() => {
                                                        setSelectedWarehouse(warehouse);
                                                        setShowEditModal(true);
                                                    }}
                                                    style={{ ...styles.button, padding: '6px 12px', fontSize: '12px', marginRight: '8px' }}
                                                >
                                                    Düzenle
                                                </button>
                                                <button
                                                    onClick={() => handleDeleteWarehouse(warehouse.id)}
                                                    style={styles.deleteButton}
                                                >
                                                    Sil
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {warehouses.length === 0 && (
                                <div style={{ textAlign: 'center', padding: '40px', color: '#64748b' }}>
                                    <p>Henüz depo eklenmemiş.</p>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
            {showAddModal && <AddWarehouseModal onClose={() => setShowAddModal(false)} onSave={handleAddWarehouse} />}
            {showEditModal && selectedWarehouse && (
                <EditWarehouseModal
                    warehouse={selectedWarehouse}
                    onClose={() => {
                        setShowEditModal(false);
                        setSelectedWarehouse(null);
                    }}
                    onSave={handleEditWarehouse}
                />
            )}
        </div>
    );
}

export default Warehouses;